var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"usermsg"},[_c('div',{staticClass:"imgbox"},[_c('img',{attrs:{"src":_vm.data[0].src}})]),_vm._v(" "),_c('mt-cell',{attrs:{"title":"名字","is-link":"","value":_vm.data[0].name,"id":"msg_el"}}),_vm._v(" "),_c('mt-cell',{attrs:{"title":"密码","is-link":"","value":"••••••","id":"msg_el"}}),_vm._v(" "),_c('p',{staticClass:"title"},[_vm._v("您的邮箱地址：")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.data[0].mail))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-695cf818","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user_msg.vue
// module id = 58
// module chunks = 0